import { Image, Pane, Text } from "evergreen-ui";
import React from "react";
import registernormal1 from "../../assets/2025/btn1.png";
import registernormal2 from "../../assets/2025/btn2.png";
import registernormal3 from "../../assets/2025/btn3.png";
import registernormal4 from "../../assets/2025/btn4.png";
import useCustomNavigate from "../../Components/CustomNavigate";

function RegisterNormall() {
    // const nav = useCustomNavigate()
  return (
    <Pane className="container-md" paddingX={20} paddingY={10}>
      <Text fontSize={18} fontWeight={600}>
        สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร
      </Text>
      <Pane marginTop={15}>
        <Text fontSize={18} fontWeight={300}>
          รอบการรับสมัคร
        </Text>
      </Pane>
      <Pane display="flex" flexWrap={"wrap"}>
        <Image
          className="col-3"
          src={registernormal1}
          width="100%"
          opacity={1}
          onClick={() => {
            localStorage.setItem("RobID", "152");
            localStorage.setItem("typestdd", "1");
            // nav("/FormRegister")
          }}
        />
        <Image className="col-3" src={registernormal2} width="100%" opacity={0.3} />
        <Image className="col-3" src={registernormal3} width="100%" opacity={0.3} />
        <Image className="col-3" src={registernormal4} width="100%" opacity={0.3} />
      </Pane>
    </Pane>
  );
}

export default RegisterNormall;
